import { connect } from 'react-redux';
import { storeAudioEnabled, storeTranscriptEnabled } from '../../store/audio';
import AudioToggles from './AudioToggles';

const mapStateToProps = state => ({
  audioEnabled: state.audio.audioEnabled,
  transcriptEnabled: state.audio.transcriptEnabled
});

const mapDispatchToProps = dispatch => ({
  audioChange: audioEnabled => {
    dispatch(storeAudioEnabled(audioEnabled));
  },
  transcriptChange: transcriptEnabled => {
    dispatch(storeTranscriptEnabled(transcriptEnabled));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AudioToggles);



// WEBPACK FOOTER //
// ../core/src/components/AudioToggles/index.js